import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { CrudStore } from 'core/types/crudStore'

import { ContactWorkflowStatus, IContact } from '../../model/types'

const contactExtOptions = { formId: '375', code: 'ContactExt' }
const keyFiled = 'EntryId'

export function removeContactRequest(contact: IContact) {
  const source = CrudStore.get(
    CrudStoreItem.ContactExt,
    `removeContactRequest-${contact.contactId}`
  )

  const isFinalWorkflowStatus =
    contact.workflowStatus &&
    [ContactWorkflowStatus.Done, ContactWorkflowStatus.Rejected].includes(contact.workflowStatus)

  const removeId = contact.entryId375 || contact.entryId

  if (isFinalWorkflowStatus) {
    return source.update(contactExtOptions, [{ EntryId: removeId }])
  }

  return source.delete(contactExtOptions, { EntryId: removeId }, keyFiled)
}
